import * as React from 'react';
import styled from 'styled-components';

import * as colors from '../colors';
import { Container, Grid, SliderArrow, SliderLabel, Statement } from './SliderInput';

interface IProps {
    statement?: string;
    leftLabel: string;
    rightLabel: string;
    showValue?: boolean;
    value: number;
    precision?: number;
}

const Rail = styled.div`
    position: absolute;
    width: 100%;
    height: 4px;
    border: 2px solid #e9e9e9;
`;

interface WithValue {
    $width: number;
}

const Track = styled.div<WithValue>`
    position: absolute;
    height: 4px;
    border: 2px solid ${colors.primaryColor};
    left: 0%;
    width: ${({ $width }) => $width}%;
`;

const Handle = styled.div<WithValue>`
    position: absolute;
    z-index: 1;
    border: solid 2px ${colors.primaryColor};
    border-radius: 50%;
    background-color: ${colors.primaryColor};
    opacity: 1;
    width: 28px;
    height: 28px;
    margin-top: -12px;
    color: white;
    text-align: center;
    user-select: none;
    transform: translateX(-50%);
    left: ${({ $width }) => $width}%;
    @media print {
        color: ${colors.primaryColor};
    }
`;

const SliderBox = styled.div`
    position: relative;
    grid-area: slider;
    height: 14px;
    padding: 10px 0;
`;

function SliderPreview({ statement, leftLabel, rightLabel, showValue, value, precision = 0 }: IProps): JSX.Element {
    return <Container>
        <Grid>
            {statement && <Statement>{statement}</Statement>}
            <SliderBox>
                <Rail />
                <Track $width={value * 10} />
                <SliderArrow $dir='left' />
                <SliderArrow $dir='right' />
                <Handle $width={value * 10}>{showValue && value.toFixed(precision)}</Handle>
            </SliderBox>
            <SliderLabel>{leftLabel}</SliderLabel>
            <SliderLabel $right>{rightLabel}</SliderLabel>
        </Grid>
    </Container>;
}

export default SliderPreview;